export default __webpack_public_path__ + "static/media/cognitive-icon.e1780be2.svg";